<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem" style="background-image: url('../../assets/images/bg/3.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Site Map</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="/">Home</a><span>Site Map</span></div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javascript:void(0);" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<!--section  -->
<section class="no-top-padding-sec" data-scrollax-parent="true">
    <div class="container">
        <div class="user-profile-header_content">
            <ul class="cat-item site-map no-list-style">
               <li *ngFor="let category of categories?.data; let i = index;">
                  <a [routerLink]="['/business', getHyphenatedString(category.CategoryName)]" title="{{category.CategoryName}}">{{category.CategoryName}}</a> <span>{{i+1}}</span>
               </li>
            </ul>
            <div class="clearfix"></div>
        </div>
    </div>
</section>
<!--section end-->